import { Link, routes, useParams } from '@cedarjs/router'
import { Metadata } from '@cedarjs/web'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { Typography, Button } from '@mui/material'

const SubmitFormConfirmationPage = () => {
  const { id } = useParams()

  return (
    <>
      <Metadata
        title="Form Submitted Successfully"
        description="Form Submission Confirmation"
      />

      <div className="flex flex-col items-center justify-center py-12">
        <CheckCircleIcon sx={{ fontSize: 64, color: 'success.main', mb: 3 }} />

        <Typography variant="h4" className="mb-4 text-green-600">
          Form Submitted Successfully!
        </Typography>

        <Typography variant="body1" color="text.secondary" className="mb-6">
          Thank you for your submission. Your form has been received and will be
          processed accordingly.
        </Typography>

        <div className="flex flex-col gap-3 sm:flex-row sm:justify-center">
          {id && (
            <Button
              variant="outlined"
              color="primary"
              component={Link}
              to={routes.submitForm({ id })}
            >
              Submit Another Response
            </Button>
          )}
        </div>
      </div>
    </>
  )
}

export default SubmitFormConfirmationPage
